module.exports = __webpack_public_path__ + "hr.svg?af6feb3bc8f0b13586c29825420d6462";